import { c as _c } from "react/compiler-runtime";
import { IcoFootprintShield16, IcoShieldFlash40 } from '@onefootprint/icons';
import type { DocumentUploadSettings } from '@onefootprint/request-types';
import { Button, Dialog, MarkdownText, Overlay } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
import { containsListOrBlockquoteMarkdown, containsNonInlineMarkdown } from './utils/contains-markdown';
type PreviewDialogProps = {
  name: string;
  description: string | undefined;
  uploadSetting: DocumentUploadSettings;
  open: boolean;
  onClose: () => void;
};
const PreviewDialog = t0 => {
  const $ = _c(17);
  const {
    open,
    onClose,
    name,
    description,
    uploadSetting
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectCustomData.preview"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== description || $[4] !== name || $[5] !== uploadSetting) {
    t3 = <Content name={name} description={description} uploadSetting={uploadSetting} />;
    $[3] = description;
    $[4] = name;
    $[5] = uploadSetting;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== onClose || $[8] !== open || $[9] !== t2 || $[10] !== t3) {
    t4 = <Dialog open={open} onClose={onClose} title={t2} size="compact" noPadding={true}>{t3}</Dialog>;
    $[7] = onClose;
    $[8] = open;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== open) {
    t5 = <Overlay isVisible={open} />;
    $[12] = open;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t4 || $[15] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
const Content = t0 => {
  const $ = _c(54);
  const {
    name,
    description,
    uploadSetting
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectCustomData.preview"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IcoShieldFlash40 />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== name || $[3] !== t) {
    t3 = name || t(_temp2);
    $[2] = name;
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <h2 className="text-label-1 text-primary text-center">{t3}</h2>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== description) {
    t5 = containsListOrBlockquoteMarkdown(description);
    $[7] = description;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = !t5;
  let t7;
  if ($[9] !== description) {
    t7 = containsNonInlineMarkdown(description);
    $[9] = description;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = !t7;
  let t9;
  if ($[11] !== t6 || $[12] !== t8) {
    t9 = cx("text-body-2 text-secondary", {
      "text-center": t6,
      "whitespace-pre-wrap": t8
    });
    $[11] = t6;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== description || $[15] !== t) {
    t10 = description || t(_temp3);
    $[14] = description;
    $[15] = t;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t9) {
    t11 = <MarkdownText className={t9}>{t10}</MarkdownText>;
    $[17] = t10;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t4) {
    t12 = <div className="flex flex-col items-center gap-2 w-full">{t2}<div className="flex flex-col gap-4">{t4}{t11}</div></div>;
    $[20] = t11;
    $[21] = t4;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t || $[24] !== uploadSetting) {
    t13 = uploadSetting === "prefer_capture" ? t(_temp4) : t(_temp5);
    $[23] = t;
    $[24] = uploadSetting;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t13) {
    t14 = <div className="flex flex-col gap-3 w-full"><Button fullWidth={true} size="large">{t13}</Button></div>;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t12 || $[29] !== t14) {
    t15 = <div className="flex flex-col items-center gap-6 p-6">{t12}{t14}</div>;
    $[28] = t12;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <IcoFootprintShield16 />;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t) {
    t17 = t(_temp6);
    $[32] = t;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t17) {
    t18 = <div className="flex gap-1">{t16}{t17}</div>;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t) {
    t19 = t(_temp7);
    $[36] = t;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t19) {
    t20 = <div>{t19}</div>;
    $[38] = t19;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div>·</div>;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  let t22;
  if ($[41] !== t) {
    t22 = t(_temp8);
    $[41] = t;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== t22) {
    t23 = <div>{t22}</div>;
    $[43] = t22;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== t20 || $[46] !== t23) {
    t24 = <div className="flex gap-1">{t20}{t21}{t23}</div>;
    $[45] = t20;
    $[46] = t23;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  let t25;
  if ($[48] !== t18 || $[49] !== t24) {
    t25 = <footer className="flex justify-between w-full px-4 py-3 border-t border-solid bg-secondary text-caption-1 text-primary border-tertiary">{t18}{t24}</footer>;
    $[48] = t18;
    $[49] = t24;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  let t26;
  if ($[51] !== t15 || $[52] !== t25) {
    t26 = <>{t15}{t25}</>;
    $[51] = t15;
    $[52] = t25;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  return t26;
};
export default PreviewDialog;
function _temp($) {
  return $.title;
}
function _temp2($) {
  return $.headerFallback;
}
function _temp3($_0) {
  return $_0.descriptionFallback;
}
function _temp4($_1) {
  return $_1.ctaCapture;
}
function _temp5($_2) {
  return $_2.ctaUpload;
}
function _temp6($_3) {
  return $_3.footer.secured;
}
function _temp7($_4) {
  return $_4.footer.about;
}
function _temp8($_5) {
  return $_5.footer.legal;
}